"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var blank_exports = {};
__export(blank_exports, {
  defaultBlankValueOptions: () => defaultBlankValueOptions,
  schemaBlankValue: () => schemaBlankValue
});
module.exports = __toCommonJS(blank_exports);
var import_geometry = require("@cartographerio/geometry");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
var import_typeCheck = require("./typeCheck.js");
const defaultBlankValueOptions = {
  genUuid: import_types.randomUuid,
  genTimestamp: import_types.nowTimestamp,
  genPoint: () => import_geometry.commonLocations.greatBritain.center
};
function schemaBlankValue(schema, opts = defaultBlankValueOptions) {
  const value = internalBlankValue(schema, opts);
  const errors = (0, import_typeCheck.typeCheck)(schema, value);
  if (errors.length > 0) {
    console.error("schemaBlankValue returned a value that did not type check against the schema", {
      schema,
      value,
      errors
    });
  }
  return value;
}
function internalProductBlankValue(schema, options) {
  return Object.fromEntries(
    Object.entries(schema.fields).map(([key, value]) => (0, import_util.tuple)(key, internalBlankValue(value, options)))
  );
}
function internalBlankValue(schema, options) {
  if (schema.defaultValue != null) {
    return schema.defaultValue;
  } else {
    switch (schema.type) {
      case "Boolean":
        return false;
      case "Integer":
        return 0;
      case "Number":
        return 0;
      case "String":
        return "";
      case "Uuid":
        return options.genUuid();
      case "Timestamp":
        return options.genTimestamp();
      case "Geometry":
        switch (schema.geometryType) {
          case "Point":
            return options.genPoint();
          case "MultiPoint":
          case "LineString":
          case "MultiLineString":
          case "Polygon":
          case "MultiPolygon":
            return null;
          case void 0:
            return options.genPoint();
          default:
            return (0, import_util.checkExhausted)(schema.geometryType);
        }
      case "Enum":
        return schema.values.length > 0 ? schema.values[0] : void 0;
      case "Nullable":
        return null;
      case "Array":
        return (0, import_lodash.range)(0, schema.defaultLength || 0).map((_index) => internalBlankValue(schema.param, options));
      case "Tuple":
        return schema.items.map((item) => internalBlankValue(item, options));
      case "Dict":
        return {};
      case "Product":
        return internalProductBlankValue(schema, options);
      case "Sum": {
        const pairs = (0, import_lodash.toPairs)(schema.products);
        if (pairs.length > 0) {
          const [name, product] = pairs[0];
          return { ...internalProductBlankValue(product, options), type: name };
        } else {
          return void 0;
        }
      }
      case "Unknown":
        return null;
      default:
        return (0, import_util.checkExhausted)(schema);
    }
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  defaultBlankValueOptions,
  schemaBlankValue
});
//# sourceMappingURL=blank.js.map
